export default __webpack_public_path__ + "static/media/showcase-declaration.4884a563.jpg";